



























































































































































































































































































































































































import * as moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Vue, Watch } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import {
  ControllersApi,
  GetUnitsResponse,
  LocationModel,
  LocationsApi,
  PostUnitRequest,
  UnitsApi,
  UserModel,
} from "../../../apis";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import ConfirmDialog from "../user-management/ConfirmDialog.vue";
import AdminLocationEditDialog from "./AdminLocationEditDialog.vue";
import { ACT, ACTION, TYPE } from "./index";
import UnitControllerDialog from "./UnitControllerDialog.vue";

export const _DEFAULT_UNIT_TYPE = "CA";
@Component({
  components: {
    MoreVertBtn,
    AdminLocationEditDialog,
    ConfirmDialog,
    ValidationProvider,
    ValidationObserver,
    UnitControllerDialog,
  },
})
export default class AdminLocationDetail extends Vue {
  tabController = true;
  tabUnit = false;

  showConfirmDeleteUnitDialog = false;
  confirmDeleteUnitContent = "";
  selectedPermisstionId = "";
  selectedPermisstion = {} as any;
  location: LocationModel = Object.assign({});

  tableUnitData = [] as any;
  unitResponse: GetUnitsResponse;

  isShowUnitControllerDialog = false;
  locationType: TYPE = null;
  mode: ACT = null;

  postUnitRequest: PostUnitRequest = {} as any;
  locationId = this.$route.params.id;
  tableControllersData = [] as any;
TIMEZONES = [
  {value: "America/Guatemala", text:"(UTC-06:00) Central America"},
  {value: "America/Chicago", text:"(UTC-06:00) Central Time (US and Canada)"},
  {value: "America/Regina", text:"(UTC-06:00) Saskatchewan"},
  {value: "America/Mexico_City", text:"(UTC-06:00) Guadalajara, Mexico City, Monterey"},
  {value: "America/Bogota", text:"(UTC-05:00) Bogota, Lima, Quito"},
  {value: "America/Indiana/Indianapolis", text:"(UTC-05:00) Indiana (East)"},
  {value: "America/New_York", text:"(UTC-05:00) Eastern Time (US and Canada)"},
  {value: "America/Caracas", text:"(UTC-04:00) Caracas"},
  {value: "America/Halifax", text:"(UTC-04:00) Atlantic Time (Canada)"},
  {value: "America/La_Paz", text:"(UTC-04:00) Georgetown, La Paz, Manaus, San Juan"},
  {value: "America/Cuiaba", text:"(UTC-04:00) Cuiaba"},
  {value: "America/St_Johns", text:"(UTC-03:30) Newfoundland"},
  {value: "America/Sao_Paulo", text:"(UTC-03:00) Brasilia"},
  {value: "America/Cayenne", text:"(UTC-03:00) Cayenne, Fortaleza"},
  {value: "America/Argentina/Buenos_Aires", text:"(UTC-03:00) Buenos Aires"},
  {value: "America/Montevideo", text:"(UTC-03:00) Montevideo"},
  {value: "America/Godthab", text:"(UTC-02:00) Greenland"},
  {value: "Etc/GMT+2", text:"(UTC-02:00) Coordinated Universal Time-2"},
  {value: "Atlantic/Cape_Verde", text:"(UTC-01:00) Cape Verde"},
  {value: "Atlantic/Azores", text:"(UTC-01:00) Azores"},
  {value: "Atlantic/Reykjavik", text:"(UTC+00:00) Monrovia, Reykjavik"},
  {value: "Europe/London", text:"(UTC+00:00) Dublin, Edinburgh, Lisbon, London"},
  {value: "Etc/GMT", text:"(UTC+00:00) Coordinated Universal Time"},
  {value: "Africa/Casablanca", text:"(UTC+01:00) Casablanca"},
  {value: "Europe/Berlin", text:"(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"},
  {value: "Europe/Paris", text:"(UTC+01:00) Brussels, Copenhagen, Madrid, Paris"},
  {value: "Africa/Lagos", text:"(UTC+01:00) West Central Africa"},
  {value: "Europe/Budapest", text:"(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"},
  {value: "Europe/Warsaw", text:"(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb"},
  {value: "Africa/Windhoek", text:"(UTC+02:00) Windhoek"},
  {value: "Europe/Kiev", text:"(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"},
  {value: "Africa/Cairo", text:"(UTC+02:00) Cairo"},
  {value: "Africa/Johannesburg", text:"(UTC+02:00) Harare, Pretoria"},
  {value: "Asia/Jerusalem", text:"(UTC+02:00) Jerusalem"},
  {value: "Asia/Beirut", text:"(UTC+02:00) Beirut"},
  {value: "Asia/Damascus", text:"(UTC+03:00) Damascus"},
  {value: "Asia/Amman", text:"(UTC+03:00) Amman"},
  {value: "Europe/Istanbul", text:"(UTC+03:00) Istanbul"},
  {value: "Asia/Baghdad", text:"(UTC+03:00) Baghdad"},
  {value: "Europe/Minsk", text:"(UTC+03:00) Minsk"},
  {value: "Asia/Riyadh", text:"(UTC+03:00) Kuwait, Riyadh"},
  {value: "Africa/Nairobi", text:"(UTC+03:00) Nairobi"},
  {value: "Europe/Moscow", text:"(UTC+03:00) Moscow, St. Petersburg, Volgograd"},
  {value: "Asia/Tehran", text:"(UTC+03:30) Tehran"},
  {value: "Asia/Tbilisi", text:"(UTC+04:00) Tbilisi"},
  {value: "Asia/Yerevan", text:"(UTC+04:00) Yerevan"},
  {value: "Asia/Dubai", text:"(UTC+04:00) Abu Dhabi, Muscat"},
  {value: "Asia/Baku", text:"(UTC+04:00) Baku"},
  {value: "Indian/Mauritius", text:"(UTC+04:00) Port Louis"},
  {value: "Asia/Kabul", text:"(UTC+04:30) Kabul"},
  {value: "Asia/Tashkent", text:"(UTC+05:00) Tashkent"},
  {value: "Asia/Karachi", text:"(UTC+05:00) Islamabad, Karachi"},
  {value: "Asia/Colombo", text:"(UTC+05:30) Sri Jayewardenepura Kotte"},
  {value: "Asia/Kolkata", text:"(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi"},
  {value: "Asia/Kathmandu", text:"(UTC+05:45) Kathmandu"},
  {value: "Asia/Almaty", text:"(UTC+06:00) Astana"},
  {value: "Asia/Dhaka", text:"(UTC+06:00) Dhaka"},
  {value: "Asia/Yangon", text:"(UTC+06:30) Yangon"},
  {value: "Asia/Bangkok", text:"(UTC+07:00) Bangkok, Hanoi, Jakarta"},
  {value: "Asia/Novosibirsk", text:"(UTC+07:00) Novosibirsk"},
  {value: "Asia/Krasnoyarsk", text:"(UTC+08:00) Krasnoyarsk"},
  {value: "Asia/Ulaanbaatar", text:"(UTC+08:00) Ulaanbaatar"},
  {value: "Asia/Shanghai", text:"(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi"},
  {value: "Australia/Perth", text:"(UTC+08:00) Perth"},
  {value: "Asia/Singapore", text:"(UTC+08:00) Kuala Lumpur, Singapore"},
  {value: "Asia/Taipei", text:"(UTC+08:00) Taipei"},
  {value: "Asia/Irkutsk", text:"(UTC+09:00) Irkutsk"},
  {value: "Asia/Seoul", text:"(UTC+09:00) Seoul"},
  {value: "Asia/Tokyo", text:"(UTC+09:00) Osaka, Sapporo, Tokyo"},
  {value: "Asia/Yakutsk", text:"(UTC+09:00) Yakutsk"},
  {value: "Australia/Darwin", text:"(UTC+09:30) Darwin"},
  {value: "Australia/Brisbane", text:"(UTC+10:00) Brisbane"},
  {value: "Pacific/Port_Moresby", text:"(UTC+10:00) Guam, Port Moresby"},
  {value: "Pacific/Guadalcanal", text:"(UTC+11:00) Solomon Islands, New Caledonia"},
  {value: "Etc/GMT-12", text:"(UTC+12:00) Coordinated Universal Time+12"},
  {value: "Pacific/Fiji", text:"(UTC+12:00) Fiji, Marshall Islands"},
  {value: "Asia/Magadan", text:"(UTC+12:00) Magadan"},
  {value: "Pacific/Tongatapu", text:"(UTC+13:00) Nuku'alofa"},
  {value: "Pacific/Apia", text:"(UTC+13:00) Samoa"},
];
  created() {
    this.initDataLocationById();
    this.initDataUnit();
    this.initDataController();
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  navigateToVariablePlc(item) {
    this.$router.push({ name: "variable-plc", params: { plcId: item.id } });
  }

  navigateToRPA(item) {
    this.$router.push({ name: "detail-rpa", params: { id: item.rpa } });
  }

  onSaveDialog() {
    this.initDataUnit();
    this.initDataController();
  }

  onDeleteUnit() {
    this.showConfirmDeleteUnitDialog = true;
    this.confirmDeleteUnitContent = `${this.$t(
      "dialog.confirmUnit.contentRemove"
    )}`;
  }

  onDeleteController() {
    this.showConfirmDeleteUnitDialog = true;
    this.confirmDeleteUnitContent = `${this.$t(
      "dialog.confirmUnit.contentRemoveController"
    )}`;
  }
  onOkConfirmDeleteUnitDialog() {
    if (this.tabController) {
      this.deleteController();
    }
    if (this.tabUnit) {
      this.deleteUnit();
    }
  }

  @Watch("editLocationClick")
  showEditDialogAction() {
    this.showEditDialog = true;
  }

  get editLocationClick() {
    return this.$store.getters.editLocationClick;
  }

  get ACTIONS(): IAction[] {
    return [
      {
        titleName: this.$t("text.edit"),
        titleStyle: "color: black; font-weight: 600",
        action: ACTION.EDIT_UNIT,
        permission: { context: "UNIT_MANAGEMENT", action: "update" },
      },
      {
        titleName: this.$t("text.delete"),
        titleStyle: "color: red; font-weight: 600",
        action: ACTION.REMOVE_UNIT,
        permission: { context: "UNIT_MANAGEMENT", action: "delete" },
      },
    ];
  }

  actionsController: Array<IAction> = [
    {
      titleName: this.$t("text.edit"),
      action: ACTION.EDIT_CONTROLLER,
      permission: { context: "CONTROLLER_MANAGEMENT", action: "update" },
      titleStyle: "color: black; font-weight: 600",
    },
    {
      titleName: this.$t("text.delete"),
      action: ACTION.REMOVE_CONTROLLER,
      permission: { context: "CONTROLLER_MANAGEMENT", action: "delete" },
      titleStyle: "color: red; font-weight: 600",
    },
  ];

  get headerControllers() {
    const headers_ = [
      {
        text: this.$t("text.ipAddress"),
        value: "ipAddress",
        cellClass: ["tw-whitespace-no-wrap"],
        class: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("unitColumn.name"),
        value: "name",
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("unitColumn.description"),
        value: "description",
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("unitColumn.variables"),
        value: "variable",
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.action"),
        value: "action",
        cellClass: ["tw-whitespace-no-wrap"],
      },
    ] as DataTableHeader[];
    if (this.$util.isClient()) {
      this.lodash.remove(headers_, { value: "action" });
    }
    return headers_;
  }

  get me() {
    return this.$store.getters.user as UserModel;
  }

  get HEADER_UNITS() {
    const headers_ = [
      {
        text: this.$t("unitColumn.name"),
        value: "name",
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("unitColumn.type"),
        value: "type",
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("unitColumn.description"),
        value: "description",
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("unitColumn.variables"),
        value: "variable",
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: "Non-Trm",
        value: "noneTreatment",
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.RPA"),
        value: "rpa",
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.action"),
        value: "action",
        cellClass: ["tw-whitespace-no-wrap"],
      },
    ];
    if (this.$util.isClient()) {
      this.lodash.remove(headers_, val => ["action", "rpa"].includes(val.value));
    }
    return headers_;
  }
  checkStatusAction() {
    return this.ACTIONS.filter((val) => val.action);
  }
  checkStatusActionController() {
    return this.actionsController.filter((val) => val.action);
  }

  onAddController() {
    this.isShowUnitControllerDialog = true;
    this.locationType = TYPE.CONTROLLER;
    this.mode = ACT.NEW;
  }

  onAddUnit() {
    this.isShowUnitControllerDialog = true;
    this.locationType = TYPE.UNIT;
    this.mode = ACT.NEW;
  }

  onSelectedPermission(item, action) {
    this.selectedPermisstion = { ...item };
    switch (action) {
      case ACTION.EDIT_UNIT: {
        this.isShowUnitControllerDialog = true;
        this.locationType = TYPE.UNIT;
        this.mode = ACT.EDIT;
        break;
      }
      case ACTION.REMOVE_UNIT: {
        this.onDeleteUnit();
        break;
      }
      case ACTION.EDIT_CONTROLLER: {
        this.isShowUnitControllerDialog = true;
        this.locationType = TYPE.CONTROLLER;
        this.mode = ACT.EDIT;
        break;
      }
      case ACTION.REMOVE_CONTROLLER: {
        this.onDeleteController();
        break;
      }
      default: {
        break;
      }
    }
  }

  async deleteUnit() {
    this.$util.showLoading();
    try {
      await new UnitsApi().deleteUnit({
        id: this.selectedPermisstion.id,
      });
      this.showConfirmDeleteUnitDialog = false;
      this.initDataUnit();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async deleteController() {
    this.$util.showLoading();
    try {
      await new ControllersApi().deleteController({
        id: this.selectedPermisstion.id,
      });
      this.showConfirmDeleteUnitDialog = false;
      this.initDataController();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  navigateMailingList() {
    return this.$router.push(
      "/customers/locations/location-detail/" +
        this.$route.params.id +
        "/mail-list"
    );
  }
  getRouteEdit() {
    return this.$router.push(
      "/customers/locations/edit-location/" + this.$route.params.id
    );
  }
  formatDate(date: Date) {
    return moment(date).format("D MMM, YYYY h:mm A");
  }
  showEditDialog = false;
  async initDataLocationById() {
    this.$util.showLoading();
    try {
      const response = await new LocationsApi().getLocationById({
        id: this.$route.params.id,
      });
      this.location = response.data.data;
    } finally {
      this.$util.hideLoading();
    }
  }

  async initDataUnit() {
    this.$util.showLoading();
    try {
      const responseData = await new UnitsApi().getUnitByLocationId({
        locationId: this.$route.params.id,
      });
      this.tableUnitData = responseData.data.data;
    } catch (error) {
    } finally {
      this.$util.hideLoading();
    }
  }
  async initDataController() {
    this.$util.showLoading();
    try {
      const responseDataController =
        await new LocationsApi().getControllersByLocationId({
          id: this.$route.params.id,
        });
      this.tableControllersData = responseDataController.data.data;
    } catch (error) {
    } finally {
      this.$util.hideLoading();
    }
  }
}
